import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import { getType, TrainingDetail } from '~/training/types';
import EmptyMessage from '../EmptyMessage';
import ResourceLink from '../ResourceLink';

export interface ExternalResourcesProps {
  resources: TrainingDetail['externalResources'];
}

export type ExternalResourcesComponent = React.FC<ExternalResourcesProps>;

const ExternalResources: ExternalResourcesComponent = ({ resources }) => {
  const { t } = useTranslation('training');

  if (!resources?.length) {
    return <EmptyMessage message={t('external.noExternalResourceAdded')} />;
  }

  return (
    <div className={classes['resources']}>
      {resources.map((externalResource) => (
        <ResourceLink
          key={externalResource.id}
          href={externalResource.url}
          icon={<Icon name={getType(externalResource.type)} />}
          title={externalResource.title}
        />
      ))}
    </div>
  );
};

export default ExternalResources;
